import { defineMessages } from 'react-intl';

const messages = defineMessages({
	dialogTitle: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.dialogTitle',
		defaultMessage: 'Select a Sleeper Option',
	},
	dialogDescription: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.dialogDescription',
		defaultMessage:
			'Choose your preferred sleeper accommodation for your journey.',
	},
	cancelButton: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.cancelButton',
		defaultMessage: 'Discard Changes',
	},
	saveButton: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.saveButton',
		defaultMessage: 'Save Sleeper',
	},
	lblLeg: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.lblLeg',
		defaultMessage: 'Leg',
	},
	lblTo: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.lblTo',
		defaultMessage: 'to',
	},
	connectingDoorsCheckbox: {
		id: 'app.Shopping.CreateBooking.SleeperSupplementsDialog.connectingDoorsCheckbox',
		defaultMessage: 'Request connecting doors (if available)',
	},
});

export default messages;
